var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIReferenceSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09851 8.39161C6.91549 8.39161 8.38843 6.91866 8.38843 5.10169C8.38843 3.28471 6.91549 1.81177 5.09851 1.81177C3.28154 1.81177 1.80859 3.28471 1.80859 5.10169C1.80859 6.91866 3.28154 8.39161 5.09851 8.39161Z",
    stroke: "#C4C8CE",
    strokeWidth: 1.13769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50049L10.0594 10.0598",
    stroke: "#C4C8CE",
    strokeWidth: 1.13769,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIReferenceSearch);
export default __webpack_public_path__ + "static/media/i_reference_search.1cf9290e3ae63c301e8ff47d1b41501a.svg";
export { ForwardRef as ReactComponent };